// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"760":"ec0d1640","953":"162d6d25"}[chunkId] + ".chunk.js");